import { Box, Flex, Heading, Image, Text } from "@chakra-ui/react";
import React, { useContext } from "react";

export const Discount = ({
  mobile,
  image,
  mode,
  tag = <></>,
  tagValue,
  title,
  subTitle,
  distance,
  forceMode = "cover",
  onClick = () => {},
}) => {
  const primaryColor = "#D82B60";

  return (
    <Flex
      className={`discount-${mode}`}
      borderRadius="15px"
      boxShadow="0 0 10px rgb(0 0 0 / 10%)"
      height={!subTitle ? "130px" : "160px"}
      direction="column"
      background="white"
      cursor="pointer"
      position="relative"
      onClick={onClick}
      transition="0.2s"
      _hover={{
        boxShadow: "0 10px 10px rgb(0 0 0 / 20%)",
        transform: "translateY(-5px)",
      }}
    >
      <Image
        borderTopRightRadius="15px"
        borderTopLeftRadius="15px"
        height={!subTitle ? "73%" : "68%"}
        objectFit={forceMode}
        src={image}
        transition="0.5s"
        _hover={{}}
        borderBottom="1px solid rgba(0,0,0,.1)"
      />
      <Box position="absolute" top="5px" right="5px">
        {tag}
      </Box>
      <Text
        background="white"
        color="rgba(0,0,0,0.3)"
        border="1px solid rgba(0,0,0,.1)"
        borderRadius="10px"
        position="absolute"
        right="10px"
        top={!subTitle ? "85px" : "99px"}
        fontSize="11px"
        padding="0px 10px"
      >
        {mode}
      </Text>
      <Flex
        paddingTop="10px"
        paddingLeft="10px"
        align="flex-start"
        direction="column"
        textAlign="left"
      >
        <Heading textAlign="left" fontSize="14px" color={primaryColor}>
          {title.substring(0, 15) + (title.length > 15 ? "..." : "")}
        </Heading>
        {subTitle ? (
          <Text marginTop="0px" color="rgba(0,0,0,0.6)" fontSize="10px">
            {subTitle.substring(0, 20) + (subTitle.length > 20 ? "..." : "")}
          </Text>
        ) : (
          <></>
        )}
      </Flex>
      {distance && distance != "0m" ? (
        <Text
          background="white"
          color="rgba(0,0,0,0.3)"
          border="1px solid rgba(0,0,0,.1)"
          borderRadius="10px"
          position="absolute"
          right="70px"
          top="99px"
          fontSize="10px"
          padding="0px 10px"
          fontWeight="bolder"
        >
          {distance}
        </Text>
      ) : (
        <></>
      )}
    </Flex>
  );
};
